import styled from 'styled-components';
import { Link } from '../../../../../../common/components/Link';

export const StyledLink = styled(Link)`
  color: inherit;
`;
